import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import Navbar from '../../components/Navbar'
import Footer from '../Home/components/Footer'
import { useMetricas } from '../Home/hooks/metricas.hook'
import Loading from '../../components/Common/Loading'
import { useAppStore } from '../../store/app-store'
import Metricas from './components/Metricas'
import DataMetricas from './components/DataMetricas'
import useLocal from '../Products/hooks/locals.hook'
import Treemap from './components/TreeMap/TreeMap'
import useRubros from '../Products/hooks/rubros.hook'
import { useAnalytics } from '../../hooks/useAnalytics'

export interface IFiltrosMetricas {
  periodo: string
  limit: number
  miLocal: boolean
  codRubro: string
}

const Estadisticas: React.FC = () => {
  const codLocal = useAppStore((store) => store.codLocal)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const defaultFiltros: IFiltrosMetricas = {
    periodo: '1d',
    limit: isMobile ? 5 : 4,
    codRubro: null,
    miLocal: true
  }
  const [filtrosProdVistos, setFiltrosProdVistos] = useState<IFiltrosMetricas>(defaultFiltros)
  const [filtrosProdFav, setFiltrosProdFav] = useState<IFiltrosMetricas>(defaultFiltros)
  const [filtrosProdContactados, setFiltrosProdContactados] = useState<IFiltrosMetricas>(defaultFiltros)
  const [filtrosLocalesContactados, setFiltrosLocalesContactados] = useState<IFiltrosMetricas>(defaultFiltros)
  const [filtrosLocalesSeguidos, setFiltrosLocalesSeguidos] = useState<IFiltrosMetricas>(defaultFiltros)
  const [filtrosRubrosVistos, setFiltrosRubrosVistos] = useState<IFiltrosMetricas>(defaultFiltros)
  const {
    metricas,
    loading,
    loadings,
    prodContactados,
    prodVistos,
    prodFavs,
    localesContactados,
    localesSeguidos,
    rubrosVistos,
    busquedaClusterizada,
    rubrosFiltros,
    fetchMetricas,
    fecthProdVistos,
    fecthProdFav,
    fecthProdContactados,
    fecthLocalesContactados,
    fecthLocalesSeguidos,
    fecthRubrosVistos,
    fecthBusquedaCluster,
    fecthRubrosFiltros
  } = useMetricas(codLocal)
  const { flatRubrosHijos } = useRubros()
  const { estadisticasEnabled } = useLocal(codLocal)
  const { track } = useAnalytics()

  useEffect(() => {
    if (codLocal) {
      fetchMetricas(true)
      fecthRubrosFiltros()
      track('vendor_open_stats', {})
    }
  }, [codLocal])

  useEffect(() => {
    estadisticasEnabled && fecthBusquedaCluster()
  }, [estadisticasEnabled])

  useEffect(() => {
    ;(estadisticasEnabled || filtrosProdVistos.miLocal) && fecthProdVistos(filtrosProdVistos)
  }, [filtrosProdVistos])

  useEffect(() => {
    ;(estadisticasEnabled || filtrosProdFav.miLocal) && fecthProdFav(filtrosProdFav)
  }, [filtrosProdFav])

  useEffect(() => {
    ;(estadisticasEnabled || filtrosProdContactados.miLocal) && fecthProdContactados(filtrosProdContactados)
  }, [filtrosProdContactados])

  useEffect(() => {
    estadisticasEnabled && fecthLocalesContactados(filtrosLocalesContactados)
  }, [filtrosLocalesContactados, estadisticasEnabled])

  useEffect(() => {
    estadisticasEnabled && fecthLocalesSeguidos(filtrosLocalesSeguidos)
  }, [filtrosLocalesSeguidos, estadisticasEnabled])

  useEffect(() => {
    estadisticasEnabled && fecthRubrosVistos(filtrosRubrosVistos)
  }, [filtrosRubrosVistos, estadisticasEnabled])

  if (loading) return <Loading />

  return (
    <>
      <Navbar title={'Estadísticas'} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
        <Metricas metricas={metricas} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: '0.8rem',
            '& > *': { minWidth: 0 }
          }}
        >
          <DataMetricas
            id="ProdVistos"
            title="Productos más visitados"
            label="visitas"
            data={prodVistos}
            rubros={filtrosProdVistos.miLocal ? rubrosFiltros : flatRubrosHijos}
            filtros={filtrosProdVistos}
            setFiltros={setFiltrosProdVistos}
            enabled={estadisticasEnabled || filtrosProdVistos.miLocal}
            loading={loadings.prodVistos}
            icono={<img src="/assets/icons_estadisticas/estadisticas_vistas.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
          <DataMetricas
            id="ProdFav"
            title="Productos favoritos"
            label="favoritos"
            data={prodFavs}
            rubros={filtrosProdFav.miLocal ? rubrosFiltros : flatRubrosHijos}
            filtros={filtrosProdFav}
            setFiltros={setFiltrosProdFav}
            enabled={estadisticasEnabled || filtrosProdFav.miLocal}
            loading={loadings.prodFavs}
            icono={<img src="/assets/icons_estadisticas/estadisticas_favoritos.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
          <DataMetricas
            id="ProdCont"
            title="Productos más contactados"
            label="contactos"
            data={prodContactados}
            rubros={filtrosProdContactados.miLocal ? rubrosFiltros : flatRubrosHijos}
            filtros={filtrosProdContactados}
            setFiltros={setFiltrosProdContactados}
            enabled={estadisticasEnabled || filtrosProdContactados.miLocal}
            loading={loadings.prodContactados}
            icono={<img src="/assets/icons_estadisticas/estadisticas_contactos.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
          <DataMetricas
            id="LocalCont"
            title="Tiendas más contactadas"
            label="contactos"
            data={localesContactados}
            rubros={flatRubrosHijos}
            filtros={filtrosLocalesContactados}
            setFiltros={setFiltrosLocalesContactados}
            enabled={estadisticasEnabled}
            loading={loadings.localesContactados}
            icono={<img src="/assets/icons_estadisticas/estadisticas_contactos.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
          <DataMetricas
            id="LocalSeg"
            title="Tiendas más seguidas"
            label="seguidores"
            data={localesSeguidos}
            rubros={flatRubrosHijos}
            filtros={filtrosLocalesSeguidos}
            setFiltros={setFiltrosLocalesSeguidos}
            enabled={estadisticasEnabled}
            loading={loadings.localesSeguidos}
            icono={<img src="/assets/icons_estadisticas/estadisticas_seguidores.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
          <DataMetricas
            id="RubrosVistos"
            title="Rubros más visitados"
            label="visitas"
            data={rubrosVistos}
            rubros={flatRubrosHijos}
            filtros={filtrosRubrosVistos}
            setFiltros={setFiltrosRubrosVistos}
            enabled={estadisticasEnabled}
            loading={loadings.rubrosVistos}
            icono={<img src="/assets/icons_estadisticas/estadisticas_vistas.svg" />}
            //iconoTitulo={<WbSunnyOutlinedIcon fontSize="small" sx={{ marginTop: '0.2rem' }} />}
          />
        </Box>
        <Treemap
          enabled={estadisticasEnabled}
          loading={loadings.busquedaClusterizada}
          title="Búsqueda"
          data={busquedaClusterizada}
        />
      </Box>
      <Footer />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(Estadisticas)
